module.exports = __webpack_public_path__ + "static/media/merchflow_no_border.3394d0ad.jpg";